import { render } from "./maskRights.vue?vue&type=template&id=6d6a67eb"
import script from "./maskRights.vue?vue&type=script&lang=js"
export * from "./maskRights.vue?vue&type=script&lang=js"

import "./maskRights.vue?vue&type=style&index=0&id=6d6a67eb&lang=css"

import exportComponent from "D:\\site\\online-photo\\watermark-remover-spa\\tipard.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__